// src/components/Portfolio/DeficienciesObjects/GreenTeaExtract.js

const B12Corrinoids = {
  productCode: "SBOVZ-TCBL-B12",
  productName: "B12-Corrinoids",
  ingredients: "Lentinula edodes",
  overview:"Orgavitaz Cobalamins (B12) is an innovation of Shiitake cultivation technology from a patented strain grown using ‘biodynamic valorization’ of growth substrate for consistent and improved metabolism of active corrinoids. The product is standardized as a concentrate primarily for mixed and coenzyme forms of cobalamins. ",
  assay:"Total Cobalamins 0.1 % (both principal and coenzyme forms)",
  coNutrients:"Incidental nutrients include Folate & Zinc (not a claim), beta-glucans, polyphenols and antioxidants.",
  studies:"Comprehensive Stability studies, Cell-assays for Nerve health, comparative studies with synthetic B12, on-going clinical trial for B12 genetic defects.",
  benefits:"Helps with B12 deficiencies (RDA claims), suitable as a nerve health supplement, supplement for diabetic neuropathy and supports as a good longevity vitamer ingredient in combination with D3, E and Omega-3.",
  functionalUse: {
    main: "💊︎ Capsule, 🍚︎ Foods, 🥛︎ Beverages, 🚰︎ ORS, ⊘ Tablets (sensitive), 🍞︎ Baking,  🧂︎ Seasonings, 🍨︎ ice creams",
    note: "(Note:- heat and light sensitive, prone to oxidative stress)"
  },
  bannerImage: [
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/Orgavitaz-B12_1.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/Orgavitaz-B12_2.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/Orgavitaz-B12_3.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/Orgavitaz-B12_4.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/Orgavitaz-B12_5.png",



  ],
   certificates: [
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L1.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L2.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L3.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L4.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L6.png",
  ]
};

export default B12Corrinoids;
